import { CollectionSearch } from '../components/collectionSearch';
import { Search } from '../components/search';
import { SearchEmpty } from '../components/searchEmpty';
import '../scss/search.scss';

(async () => {
  const search = new Search();
  const collectionSearch = new CollectionSearch();
  /* Call async init methods for search and collection search */
  await search._init();
  await collectionSearch._init();
  /* Prove if search is empty */
  new SearchEmpty(search.totalResults, collectionSearch.length);
})();
